import { render, staticRenderFns } from "./DescontoQuantidadeModal.vue?vue&type=template&id=c8d8761a&scoped=true"
import script from "./DescontoQuantidadeModal.vue?vue&type=script&lang=js"
export * from "./DescontoQuantidadeModal.vue?vue&type=script&lang=js"
import style0 from "./DescontoQuantidadeModal.vue?vue&type=style&index=0&id=c8d8761a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d8761a",
  null
  
)

export default component.exports